import { Nilable } from "@shared/utils";
import { AgeRangeDTO, IAgeRangeDTO } from "./AgeRange.DTO";

export interface IComparatorRespuestaDTO {
    quality: number;
    first: IAgeRangeDTO[];
    second: IAgeRangeDTO[];
}


export class ComparatorRespuestaDTO {
    quality: number;
    training: AgeRangeDTO[];
    prediction: AgeRangeDTO[];

    constructor(json: Nilable<Partial<IComparatorRespuestaDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }
    cargarDTO(json: Partial<IComparatorRespuestaDTO>) {
        if (json?.quality != null) {
            this.quality = json.quality;
        }
        if (json?.first != null) {
            json.first.forEach(element => {
                this.training.push(new AgeRangeDTO(element))
            });
        }
        if (json?.second != null) {
            json.second.forEach(element => {
                this.prediction.push(new AgeRangeDTO(element))
            });
        }
    }
}
